import MagazineCard from '../components/MagazineCard';
import { getMagazines, createMagazine } from '../api/api';
import { useEffect, useState } from 'react';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';


function Home() {
  const [magazines, setMagazines] = useState([]);
  const [isVisible, setIsVisible] = useState(false)
  const [input, setInput] = useState({ name: '', description: '' })
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    loadMagazines()
  }, []);

  const handleInputChange = (e) => {
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    if (validate()) {
      setIsLoading(true)
      await createMagazine(input)
      setIsLoading(false)
      setIsVisible(false)
      loadMagazines()
    }
  }

  const validate = () => {
    let errors = {}
    if (!input.name) {
      errors.name = "Elija un nombre";
    }
    setErrors(errors)
    return Object.keys(errors).length === 0;
  }

  const loadMagazines = async () => {
    getMagazines().then((data) => {
      setMagazines(data);
    });
  }

  return (
    <div className='p-4 pt-4'>
      <Button style={{ marginBottom: '20px' }} label='Crear nueva revista' onClick={() => setIsVisible(true)} />
      <Dialog header='Crear revista' contentStyle={{ display: 'flex', flexDirection: 'column', width: '30vw' }} visible={isVisible} onHide={() => setIsVisible(false)}>
        <p>Nombre</p>
        <InputText name='name' value={input.name} onChange={handleInputChange} />
        {errors.name && <p className='errorText'>{errors.name}</p>}
        <p>Descripción</p>
        <InputTextarea name='description' value={input.description} onChange={handleInputChange} />
        <Button style={{ marginTop: '20px' }} label='Crear' onClick={handleSubmit} loading={isLoading} />
      </Dialog>
      <div class="grid">
        {magazines?.map(magazine => {
          return (
            <div className="col-12 md:col-6 lg:col-3">
              <MagazineCard magazine={magazine} />
            </div>
          )
        })}
      </div>
    </div>
  );
}

export default Home;